import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01405542"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-6 regist-h" }, "店舗エラー")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-small" }, " 店舗が選択されていません ")
], -1))

import { onMounted } from 'vue'
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  emits: ['stopLoading'],
  setup(__props, { emit }) {



const router = useRouter();

onMounted(async() => {
  emit('stopLoading');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}
}

})